import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Palette, Zap, Smartphone, Search, TrendingUp, Clock } from 'lucide-react';

const WhyUs = () => {
  const { t } = useLanguage();

  const advantages = [
    { icon: Palette, titleKey: 'whyUs.modernDesign', descKey: 'whyUs.modernDesignDesc' },
    { icon: Zap, titleKey: 'whyUs.fastDelivery', descKey: 'whyUs.fastDeliveryDesc' },
    { icon: Smartphone, titleKey: 'whyUs.mobileOptimized', descKey: 'whyUs.mobileOptimizedDesc' },
    { icon: Search, titleKey: 'whyUs.seoReady', descKey: 'whyUs.seoReadyDesc' },
    { icon: TrendingUp, titleKey: 'whyUs.highConversion', descKey: 'whyUs.highConversionDesc' },
    { icon: Clock, titleKey: 'whyUs.alwaysOnline', descKey: 'whyUs.alwaysOnlineDesc' },
  ];

  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-24 md:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-8 bg-[#B8860B]"></div>
            <span className="mx-3 text-[#B8860B] text-xs tracking-[0.2em] uppercase">{t('nav.whyUs')}</span>
            <div className="h-px w-8 bg-[#B8860B]"></div>
          </div>
          <h2
            data-testid="why-us-title"
            className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-light text-white tracking-tight"
          >
            {t('whyUs.title')}
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {advantages.map((item, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden bg-[#0A0A0A] border border-white/5 rounded-xl p-6 md:p-8 transition-all duration-300 hover:border-[#B8860B]/30 hover:-translate-y-1 ${
                index === 0 ? 'lg:row-span-2' : ''
              } ${index === 4 ? 'lg:col-span-2' : ''}`}
              data-testid={`why-us-card-${index}`}
            >
              {/* Icon */}
              <div className="mb-6">
                <div className="w-12 h-12 bg-[#B8860B]/10 rounded-xl flex items-center justify-center group-hover:bg-[#B8860B]/20 transition-colors duration-300">
                  <item.icon size={24} strokeWidth={1.5} className="text-[#B8860B]" />
                </div>
              </div>

              {/* Content */}
              <h3 className="font-outfit text-lg md:text-xl font-medium text-white mb-2">
                {t(item.titleKey)}
              </h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">
                {t(item.descKey)}
              </p>

              {/* Decorative Element */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#B8860B] to-transparent group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
